import type { Prospect } from "@/lib/types";

export type ProspectUpdate = Partial<
  Pick<
    Prospect,
    | "personalization_subject"
    | "personalization_body"
    | "personalization_chosen_variant_idx"
    | "review_notes"
    | "status"
  >
>;

export function buildApprovePayload(args: {
  variantIdx: number;
  subject: string;
  body: string;
}): ProspectUpdate {
  return {
    personalization_subject: args.subject,
    personalization_body: args.body,
    personalization_chosen_variant_idx: args.variantIdx,
    status: "ready",
  };
}

export function buildRejectPayload(note: string): ProspectUpdate {
  return { status: "rejected", review_notes: note.trim() ? note.trim() : null };
}
